import {
  cloudRequest,
  createHandleGatewayRequest,
  currentDomainID,
  gatewayPlugin,
  responseHandlerPlugin,
  bytecloudAsyncJwtService
} from "@bytecloud/common-lib";
import { allCloudApiConfigs } from "@bytecloud/cloud-api-config";
import { getGatewayDomainId } from "../utils";
const rewriteRules = [
  {
    match: "/api/v1/cloud/",
    rewrite({ originalUrl, targetDomainID }) {
      const config = allCloudApiConfigs;
      const baseUrl = config[targetDomainID].page;
      return originalUrl.replace("/api/v1/cloud", baseUrl);
    }
  },
  {
    match: "/api/v1/iam/",
    rewrite({ originalUrl, targetDomainID }) {
      const config = allCloudApiConfigs;
      const baseUrl = config[targetDomainID].iam;
      return originalUrl.replace("/api/v1/iam", baseUrl);
    }
  }
];
const rewrittenDomainID = [
  // 'local',
  // 'sandbox',
  "boe",
  "online",
  "hl",
  "lq",
  "i18n",
  "i18n-sg",
  "us",
  "boe-i18n",
  // 'tx',
  // 'tx-tt',
  "ttp-us",
  "ttp-us-limited",
  // 'xfl',
  // 'sinf-xfl-boe',
  // 'sinf-xfl',
  "sinf-boe",
  "sinf",
  "sinfi18n",
  "sinfonlinea",
  "volcgroup",
  "volcgroup-boe",
  "ttp-row",
  "ttp-row-sg"
];
const handleGatewayRequest = createHandleGatewayRequest({
  rewriteRules,
  rewrittenDomainID,
  defaultDomainID: currentDomainID,
  defaultGatewayKey: window.defaultCloudGatewayKey
});
const bytecloudRequest = cloudRequest({
  plugins: [
    "locale",
    gatewayPlugin({
      handleGatewayRequest
    }),
    // 检查 error_code 非 0
    responseHandlerPlugin()
  ]
});
function getAPIVolcEnv(volcEnv = "online") {
  return volcEnv === "byteplus" ? "byteplus_online" : `cn_${volcEnv}`;
}
const fetchSignToken = async (redirect, volcAccountId, volcEnv = "online") => {
  const onlineJWT = await bytecloudAsyncJwtService.getJwt("online");
  return bytecloudRequest.post(
    "/api/v1/tenant/v1/saml/GetSigninTokenBySaml",
    {
      redirect,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      main_account_id: volcAccountId,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      volc_env: getAPIVolcEnv(volcEnv)
    },
    {
      pluginConfig: {
        domainID: getGatewayDomainId(volcEnv)
      },
      headers: {
        "x-jwt-token": onlineJWT,
        "x-sinf-jwt-token": onlineJWT
      }
    }
  ).then((res) => res.data);
};
export {
  bytecloudRequest,
  fetchSignToken,
  getAPIVolcEnv,
  handleGatewayRequest
};
